import { Inject, Injectable } from '@angular/core';
import { IUnitOfWorkFactory } from 'src/app/common/contracts/unit-of-work/unit-of-work-factory';
import { ProofOfServiceDB } from 'src/app/common/repository/databases';
import { UnitOfWorkFactory } from 'src/app/common/unit-of-work/unit-of-work-factory';
import { ProofOfServiceDto } from 'src/app/shared/models/proof-of-service/proof-of-service-dto.model';

import { WorkItem } from '../work-item';

@Injectable({ providedIn: 'root' })
export class ProofOfServiceWorkItem extends WorkItem<ProofOfServiceDto> {
  constructor(@Inject(UnitOfWorkFactory) unitOfWorkFactory: IUnitOfWorkFactory) {
    super(unitOfWorkFactory);
  }
  get name(): string {
    return 'ProofOfServiceWorkItem';
  }
  get database(): string {
    return ProofOfServiceDB;
  }
  get chunkSize(): number {
    return 50;
  }
}
